import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import {
    MIN_PEAK,
    SPARKLINE_HEIGHT,
    SPARKLINE_STROKE_WIDTH,
    SPARKLINE_WIDTH,
    TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Sparkline: FunctionComponent<Props> = ({
    className = '',
    label,
    testId = TEST_ID,
    values
}) => {
    const peak = Math.max(...values, MIN_PEAK);
    const step = SPARKLINE_WIDTH / (values.length - 1);
    const points = values
        .map((value, index) => {
            const x = (index * step).toFixed(1);
            const y = (SPARKLINE_HEIGHT - (value / peak) * SPARKLINE_HEIGHT).toFixed(1);

            return `${x},${y}`;
        })
        .join(' ');

    return (
        <VerticalContainer className={className} testId={testId}>
            <Wrapper className={styles.sparkLabel}>{label}</Wrapper>

            <svg
                aria-hidden='true'
                className={styles.sparkline}
                preserveAspectRatio='none'
                viewBox={`0 0 ${SPARKLINE_WIDTH} ${SPARKLINE_HEIGHT}`}>
                <polyline
                    fill='none'
                    points={points}
                    stroke='var(--maintenance-sparkline-stroke)'
                    strokeWidth={SPARKLINE_STROKE_WIDTH}
                />
            </svg>
        </VerticalContainer>
    );
};

export default Sparkline;
